import React from "react"

import ImageSelector from "../../../common/ImageSelector"
import {
    topicTypes,
    topicDimensionStatuses
} from "../../../../config/application-definitions"

const InsightAreaEditItemDetails = ({
    name,
    type,
    description,
    status,
    imageUrl,
    imagePreviewURL,
    onEventChange,
    onImageChange
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-headline" />Name
            </h3>
            <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                value={name}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-insights" />Type
            </h3>
            <select
                name="type"
                className="form-control"
                value={type || "Customised"}
                onChange={onEventChange}
            >
                {topicTypes.map(({ name }) => (
                    <option key={name} value={name}>
                        {name}
                    </option>
                ))}
            </select>
            <h3>
                <span className="icon icon-status" />Status
            </h3>
            <select
                name="status"
                className="form-control"
                value={status || "Active"}
                onChange={onEventChange}
            >
                {topicDimensionStatuses.map(statusOption => (
                    <option key={statusOption} value={statusOption}>
                        {statusOption}
                    </option>
                ))}
            </select>
            <h3>
                <span className="icon icon-description" />Description
            </h3>
            <textarea
                name="description"
                className="form-control"
                placeholder="Description"
                value={description}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <ImageSelector
                onImageSelect={onImageChange}
                imageUrl={
                    imagePreviewURL !== undefined ? imagePreviewURL : imageUrl
                }
            />
        </div>
    </div>
)

export default InsightAreaEditItemDetails
